module.exports = __webpack_public_path__ + "assets/img/travel-day1.8cc704fd.png";